import { createTheme} from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      // red
      main: "#b20933",
      
    },
    secondary: {
      // grey
      main: '#868D96',
    },
    tertiary: {
      // grey
      main: '#ffffff',
    }
  },
  breakpoints: {
    values: {
      mobile: 0,
      tablet: 768,
      laptop: 991,
      desktop: 1200,
    },
  },
  components: {
    // Name of the component
    MuiSwitch: {
      styleOverrides: {
        // Name of the slot
        thumb: {
          // Some CSS
          backgroundColor: "#e1a0b0",
          // opacity:0.3
        },
        track:{
          backgroundColor: "#b20933",
          opacity:0.1
        },
        switchBase:{
          // backgroundColor: "#b20933",
          "&:hover": {
            backgroundColor: "#b209331a",
            
          },
        }
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: "12px",
        }
      }
    }
  },
});

export default theme;